import { u as i } from "../../jsxRuntime.module-Bzuv3cXw.js";
import { s as l } from "../../index.es-XNBESE3P.js";
import { B as m } from "../../BaseElement-iXMoOyxY.js";
import { a as p } from "../../useActions-Cd7V2qfb.js";
import { useCallback as f } from "preact/hooks";
import { S as x } from "../../SerpPageProvider-Ca6ZoAOq.js";
const S = "nosto:search:scrollPos";
function g() {
  window.sessionStorage.setItem(S, window.scrollY.toString());
}
function C({ children: s, hit: o, componentProps: t, as: c }) {
  const { pageType: r } = p(), e = r === "autocomplete" ? void 0 : r === "search" ? "serp" : r, a = f(() => {
    o && e && l((n) => n.recordSearchClick(e, o)), g();
  }, [o, e]);
  return /* @__PURE__ */ i(m, { as: c, onClick: a, componentProps: t, children: s });
}
export {
  x as SearchPageProvider,
  C as SerpElement
};
